export default "__VITE_ASSET__mRPOdnAb__"